import { z } from 'zod'

export type SignificantHazardFormData = {
  number: string
  description: string
  category: string
  examplesOfHazardousSituations: string
  associatedActivity: string
  relatedDangerZone: string
  clauseReference: string
}

export const significantHazardFormSchema = z.object({
  number: z.string().trim().min(1),
  description: z.string().trim().min(1),
  category: z.string(),
  examplesOfHazardousSituations: z.string(),
  associatedActivity: z.string(),
  relatedDangerZone: z.string(),
  clauseReference: z.string(),
})

export function validateSignificantHazardForm(data: SignificantHazardFormData) {
  return significantHazardFormSchema.safeParse(data)
}
